import { CdkTreeModule } from '@angular/cdk/tree';
import { NgModule } from '@angular/core';
import { NNestedTreeNodeDirective, NTreeNodeDirective, NTreeNodeDefDirective } from './node.directive';

import { NTreeNodeOutletDirective } from './outlet.directive';
import { NTreeNodePaddingDirective } from './padding';
import { NTreeNodeToggleDirective } from './toggle.directive';
import { NTreeComponent } from './tree.component';

const components = [
  NNestedTreeNodeDirective,
  NTreeComponent,
  NTreeNodeDirective,
  NTreeNodeDefDirective,
  NTreeNodeOutletDirective,
  NTreeNodePaddingDirective,
  NTreeNodeToggleDirective,
];

@NgModule({
  declarations: components,
  exports: [components],
  imports: [CdkTreeModule],
})
export class TreeModule {}
